export const schema = {
	// eventually we'll be able to import json as a module: https://github.com/w3ctag/design-reviews/issues/375
	json: JSON.parse(
		document.querySelector('script[type="application/ld+json"]').innerText
	),
	get: function(graph_node, desired_value) {
		if (!document.querySelector('script[type="application/ld+json"]')) {
			console.error(`💩 schema not present`);
		}
		for (const obj of this.json['@graph']) {
			// graph_node as @type = 'Person', graph_node as @id = '#author'
			if (obj['@type'] == graph_node || obj['@id'].includes(graph_node)) {
				try {
					// transforming a dot-notated string ('something.property') into object references
					// https://stackoverflow.com/a/6394168
					return desired_value.split('.').reduce((o, i) => o[i], obj);
				} catch (error) {
					console.error(
						`💩 ${desired_value} doesn’t exist in ${graph_node}: ${error.message}`
					);
				}
			}
		}
		return null;
	}
};
